import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { withFormik, Form, getIn, Field } from 'formik';
import { Row, Col } from 'react-bootstrap';
import { Calendar, FormikCheckBox, FormikInput, FormikNumber } from '../../../components';

const ShiftMonth = ({ values, errors, touched, setFieldValue, shift }) => {
  const [events, setEvents] = useState([]);

  const validEvent = newEvent => !events.some(item => item.title === newEvent.title && item.date === newEvent.date);

  const setValidEvents = eventArray => {
    if (!eventArray) return [];
    return eventArray.filter(item => item.send).map(item => ({ title: item.title, date: item.date, id: item.id }));
  };

  const onDropEvent = ({ dateStr, draggedEl }) => {
    const { firstChild } = draggedEl;
    const [startTime, endTime] = firstChild.data.replace(/\s/g, '').split('-');
    const { shiftDaysAttributes } = values.shift;
    const newEvent = { title: firstChild.data, startTime, endTime, date: dateStr, send: true };
    if (validEvent(newEvent)) {
      setEvents(setValidEvents([...shiftDaysAttributes, newEvent]));
      setFieldValue('shift[shiftDaysAttributes]', [...shiftDaysAttributes, newEvent]);
    }
  };

  useEffect(() => {
    setEvents(shift.shiftDaysAttributes.map(item => ({ id: item.id, title: item.title, date: item.date })));
  }, [shift]);

  return (
    <>
      <Form>
        <Row>
          <Col md={6}>
            <Field name="shift[name]">
              {({ field }) => (
                <FormikInput
                  {...field}
                  abbr
                  disabled
                  label="Nombre"
                  placeholder="NOMBRE DE TURNO"
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
          <Col xs={6} md={3}>
            <Field name="shift[parsedLunchTime]">
              {({ field }) => (
                <FormikNumber
                  {...field}
                  abbr
                  disabled
                  label="Colación"
                  rightAddon="min"
                  placeholder="0"
                  fieldName="shift[lunchTime]"
                  value={values.shift.lunchTime}
                  tooltipSize="21"
                  tooltipText="Duración en minutos del tiempo de colación"
                  setFieldValue={setFieldValue}
                  errors={errors}
                  touched={touched}
                />
              )}
            </Field>
          </Col>
          <Col xs={6} md={3}>
            <Field name="shift[parsedTolerance]">
              {({ field }) => (
                <FormikNumber
                  {...field}
                  abbr
                  disabled
                  label="Tolerancia"
                  rightAddon="min"
                  placeholder="0"
                  fieldName="shift[tolerance]"
                  value={values.shift.tolerance}
                  tooltipSize="21"
                  tooltipText="Minutos permitidos para marcar ingreso y salida fuera del horario"
                  setFieldValue={setFieldValue}
                  errors={errors}
                  touched={touched}
                />
              )}
            </Field>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} md={3} className="d-flex align-items-center">
            <Field name="shift[workHolidays]">
              {({ field }) => (
                <FormikCheckBox
                  {...field}
                  custom
                  disabled
                  field={field}
                  label="TRABAJA FESTIVOS"
                  tooltipSize="21"
                  tooltipText="Turno con días festivos incluídos"
                />
              )}
            </Field>
          </Col>
          <Col xs={6} md={3} className="d-flex align-items-center">
            <Field name="shift[lunchCheck]">
              {({ field }) => (
                <FormikCheckBox
                  {...field}
                  custom
                  disabled
                  field={field}
                  label="MARCAR COLACIÓN"
                  tooltipSize="21"
                  tooltipText="Indica si deben marcar el ingreso y salida de colación"
                />
              )}
            </Field>
          </Col>
        </Row>
        <hr />
        <Calendar events={events} drop={onDropEvent} />
        <hr />
      </Form>
    </>
  );
};

const setInitialValues = props => {
  const { shiftDaysAttributes } = props.shift;
  let shiftDays = [];
  if (shiftDaysAttributes.length) {
    shiftDays = shiftDaysAttributes.map(item => ({ ...item, send: true }));
  }

  return {
    shift: {
      ...props.shift,
      shiftDaysAttributes: shiftDays,
      shiftType: 'monthly'
    }
  };
};

const validationSchema = Yup.object().shape({
  shift: Yup.object().shape({
    lunchCheck: Yup.boolean(),
    workHolidays: Yup.boolean(),
    tolerance: Yup.number()
      .required('Debes ingresar un número')
      .min(0, 'Debe ser mayor o igual a 0'),
    lunchTime: Yup.number()
      .required('Debes ingresar tiempo de colación')
      .min(0, 'Debe ser mayor o igual a 0'),
    name: Yup.string().required('Debes ingresar un nombre'),
    shiftDaysAttributes: Yup.array().of(
      Yup.object().shape({
        endTime: Yup.string().required('Debes ingresar hora de término'),
        startTime: Yup.string().required('Debes ingresar hora de inicio')
        // date: Yup.date()
      })
    )
  })
});

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;
  formRequest(values, setSubmitting);
};

export default withFormik({
  mapPropsToValues: props => setInitialValues(props),
  validationSchema,
  handleSubmit,
  enableReinitialize: true,
  validateOnMount: props => props.action !== 'new'
})(ShiftMonth);
